import { LEAD_OUTCOMES, LEAD_OUTCOME_LABELS, LEAD_OUTCOME_TABLE, OUTCOME_STAGE_LABELS, OUTCOME_STAGE_ORDER, type LeadOutcome } from '../../types/leadOutcome.js';

// THE PICKER'S GROUPING (Speed to Lead Stage 4.5C): the shared outcome list laid out by stage, derived from the ONE table
// (src/types/leadOutcome.ts), never restated. The starting state ("Not classified yet") is its own last group so a person
// can put a lead back, and so a model suggestion is never offered as that.

export interface OutcomeGroup {
  label: string;
  outcomes: Array<{ code: LeadOutcome; label: string }>;
}

export const OUTCOME_GROUPS: OutcomeGroup[] = [
  ...OUTCOME_STAGE_ORDER.map((stage) => ({
    label: OUTCOME_STAGE_LABELS[stage],
    outcomes: LEAD_OUTCOMES.filter((o) => LEAD_OUTCOME_TABLE[o].stage === stage).map((code) => ({ code, label: LEAD_OUTCOME_LABELS[code] })),
  })),
  { label: 'Not classified', outcomes: [{ code: 'unresolved' as LeadOutcome, label: LEAD_OUTCOME_LABELS.unresolved }] },
];

/** Who or what set the outcome, in words a club reads. */
export function outcomeSetByText(setBy: 'person' | 'ai' | 'system' | null): string | null {
  if (setBy === 'person') return 'Set by a person';
  if (setBy === 'ai') return 'Suggested by AI: confirm or change it';
  if (setBy === 'system') return 'Set automatically';
  return null;
}
